import { AuthTransaction } from '@mgmresorts/mgm-auth-js-sdk';
import { useCallback, useState } from 'react';

import { verifyTokenRequest } from '../../api/fetch/verify-token';
import { useContent } from '../../hooks/useContent';

export const useResetTokenVerification = () => {
  const [isLoading, setIsLoadingState] = useState(false);
  const { getContentByPath } = useContent();

  const verifyToken = useCallback(
    async (token?: string): Promise<AuthTransaction> => {
      try {
        if (!token) {
          throw Error('invalid token');
        }
        setIsLoadingState(true);
        const transaction = await verifyTokenRequest({
          recoveryToken: String(token),
        });

        return transaction;
      } catch (error) {
        console.error(error);
        throw Error(getContentByPath('resetPassword.errors.tokenValidationError'));
      }
    },
    [getContentByPath],
  );

  return {
    isVerifyingToken: isLoading,
    verifyToken,
  };
};
